




















import Vue from 'vue';
import Component from 'vue-class-component';

const IconArrowRight = () => import('@/common/icons/arrow-right.svg');
const IconArrowExternal = () => import('@/common/icons/arrow-external.svg');

const RelaunchButtonProps = Vue.extend({
  props: {
    text: String,
    externalLink: String,
    internalLink: String,
    linkTarget: String,
    theme: {
      type: String,
      default: 'dark',
      validator: (val) => ['dark', 'light'].includes(val),
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (val) => ['primary', 'secondary'].includes(val),
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'm',
      validator: (val) => ['s', 'm', 'l'].includes(val),
    },
    isTextlink: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});

@Component({
  components: {
    IconArrowRight,
    IconArrowExternal,
  },
})
export default class RelaunchButton extends RelaunchButtonProps {
  get link () {
    return this.externalLink || this.internalLink;
  }

  get buttonClasses () {
    return {
      'brandhub-relaunch-button--theme-light': this.theme === 'light',
      'brandhub-relaunch-button--variant-primary': this.variant === 'primary',
      'brandhub-relaunch-button--variant-secondary': this.variant === 'secondary',
      'brandhub-relaunch-button--size-s': this.size === 's',
      'brandhub-relaunch-button--size-m': this.size === 'm',
      'brandhub-relaunch-button--size-l': this.size === 'l',
      'brandhub-relaunch-button--text-link': this.isTextlink,
      'brandhub-relaunch-button--disabled': this.disabled,
    };
  }
}
